"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const errors_1 = require("./errors");
class ApiClient {
    static throwBadRequestError(loc, msg, type, statusCode) {
        throw new errors_1.BadRequestError([
            {
                loc: [loc],
                msg,
                type,
            },
        ], statusCode);
    }
}
exports.default = ApiClient;
//# sourceMappingURL=ApiClient.js.map